/* global latitude, longitude */
import mapboxgl from 'mapbox-gl';

function initMap() {
  if (typeof latitude === 'undefined' || typeof longitude === 'undefined') {
    return;
  }

  if (!mapboxSettings || !mapboxSettings.accessToken) {
    return;
  }
  mapboxgl.accessToken = mapboxSettings.accessToken;

  const lat = latitude.toString().replace(',', '.');
  const lng = longitude.toString().replace(',', '.');

  const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [lng, lat],
    zoom: 16,
  });

  map.scrollZoom.disable();

  const primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--primary-color')
    .trim();

  // eslint-disable-next-line quotes
  let svgMarker = `<svg fill="none" height="49" viewBox="0 0 36 49" width="36" xmlns="http://www.w3.org/2000/svg"><path d="m20.1562 46.875c-1.125 1.4062-3.2812 1.4062-4.4062 0-4.7812-6.0938-15.75-20.625-15.75-28.875 0-9.9375 8.0625-18 18-18s18 8.0625 18 18c0 8.25-10.9688 22.7812-15.8438 28.875zm-2.1562-34.875c-2.1562 0-4.125 1.2188-5.25 3-1.0312 1.875-1.0312 4.2188 0 6 1.125 1.875 3.0938 3 5.25 3 2.0625 0 4.0312-1.125 5.1562-3 1.0313-1.7812 1.0313-4.125 0-6-1.125-1.7812-3.0937-3-5.1562-3z" fill="#012169"/></svg>`;
  svgMarker = svgMarker.replace(
    /fill="#[0-9a-fA-F]{6}"/,
    `fill="${primaryColor}"`
  );
  const customMarker = document.createElement('div');
  customMarker.innerHTML = svgMarker;

  const marker = new mapboxgl.Marker({
    element: customMarker,
    anchor: 'bottom',
  })
    .setLngLat([lng, lat])
    .addTo(map);
}

initMap();
